import React from 'react';
import { useOrgProfileStore } from '../stores/orgProfileStore';
import OrgProfileModal from './OrgProfileModal';

/** The one organisation-profile modal, driven by `useOrgProfileStore`. */
export default function OrgProfileHost() {
  const open = useOrgProfileStore((state) => state.open);
  const closeOrgProfile = useOrgProfileStore((state) => state.closeOrgProfile);
  return (
    <OrgProfileModal
      open={open}
      onClose={closeOrgProfile}
    />
  );
}
